import styled from '@emotion/styled';
import { Col } from '../../common/v2/TwoSidedLayout/TwoSidedLayout.style';
import { TabletWidth } from '../../../global.style';
import { getColor } from '../../common/UICommon';

export const EnterEmailV2LeftCol = styled(Col)`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: ${TabletWidth}px) {
    justify-content: center;
  }
`;

export const EnterEmailV2StepContent = styled.div`
  max-width: 460px;
  margin-left: 90px;
  margin-right: 10px;

  @media (max-width: ${TabletWidth}px) {
    margin-left: 0px;
    max-width: 100%;
    padding: 76px 24px 32px;
  }
`;

export const EnterEmailV2StepTitle = styled.h6`
  font-family: Lora;
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  margin-bottom: 32px;
  color: ${getColor('GRAY_80')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
  }
`;

export const EnterEmailV2StepAgreement = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 32px;
  margin-bottom: 52px;

  color: ${getColor('BLACK_60')};
`;
export const EnterEmailV2StepAgreementBreak = styled.br`
  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const EnterEmailV2ButtonWrapper = styled.div`
  max-width: 270px;
`;
